import { useState, useRef, useEffect, useMemo } from 'react';

import { useGetNewDialogs } from '../api/getNewDialog';
import { analyticsTypes } from '../types';
import { sortNewDialogs } from '../utils/sortNewDialogs';

export const useNewDialogsData = (
  pushStats: (data: Record<string, number>, updatedAt: number) => void
) => {
  const { refetch, error, isLoading } = useGetNewDialogs();
  const [stats, setStats] = useState<analyticsTypes.NewDialogsStats>();
  const prevOrderRef = useRef<string[]>([]);

  const applyStats = (next: analyticsTypes.NewDialogsStats) => {
    setStats((prev) => {
      if (prev) {
        prevOrderRef.current = Object.keys(prev.data);
      }

      pushStats(next.data, next.respondedAt);

      return next;
    });
  };

  const updateStats = async () => {
    const res = await refetch();

    if (res.data) {
      applyStats(res.data);
    }
  };

  useEffect(() => {
    updateStats();
    const interval = setInterval(updateStats, 60000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sortedStats = sortNewDialogs(prevOrderRef, stats);
  const pageKeys = useMemo(() => Object.keys(stats?.data ?? {}), [stats?.data]);

  return { stats, sortedStats, pageKeys, updateStats, error, isLoading };
};
